import { ReactNode } from "react";
import { formatDate } from "../../../utils/time";
import CustomModal from "../../common/CustomModal";

type Props = {
  open: boolean;
  handleClose: () => void;
  data?: any;
};

export default function ViewPaymentModal({ handleClose, data }: Props) {
  const result = (
    data?.response && typeof data?.response === "string"
      ? JSON.parse(data?.response)
      : data?.response
  )?.data;

  return (
    <>
      <CustomModal
        width={800}
        title="Payment Response"
        open
        handleClose={handleClose}
      >
        <div className="p-4">
          <table className="w-full border-collapse">
            <tbody>
              <TableRow label="Amount">{result?.amount}</TableRow>
              <TableRow label="Bill Type">{result?.billType}</TableRow>
              <TableRow label="Biller Type">{result?.billerType}</TableRow>
              <TableRow label="Branch Code">{result?.branchCode}</TableRow>
              <TableRow label="Card Cavv">{result?.cardCavv}</TableRow>
              <TableRow label="Card Expiry">{result?.cardExpiry}</TableRow>
              <TableRow label="Card Holder Name">
                {result?.cardHolderName}
              </TableRow>
              <TableRow label="Card Number">{result?.cardNumber}</TableRow>
              <TableRow label="Card Type">{result?.cardType}</TableRow>
              <TableRow label="Charge Amount">{result?.chargeAmount}</TableRow>
              <TableRow label="Charge Payer">{result?.chargePayer}</TableRow>
              <TableRow label="Commission Amount">
                {result?.commissionAmount}
              </TableRow>
              <TableRow label="Convenience Fee">
                {result?.convenienceFee}
              </TableRow>
              <TableRow label="Created At">
                {result?.createdAt ? formatDate(result?.createdAt) : null}
              </TableRow>
              <TableRow label="Current Balance">
                {result?.currentBalance}
              </TableRow>
              <TableRow label="Deposit Branch Name">
                {result?.depositBranchName}
              </TableRow>
              <TableRow label="Destination Amount">
                {result?.destinationAmount}
              </TableRow>
              <TableRow label="Destination Wallet">
                {result?.destinationWallet}
              </TableRow>
              <TableRow label="Id">{result?.id}</TableRow>
              <TableRow label="Partner Id">{result?.partnerId}</TableRow>
              <TableRow label="Partner Name">{result?.partnerName}</TableRow>
              <TableRow label="Partner Response">
                {result?.partnerResponse}
              </TableRow>
              <TableRow label="Partner Session Id">
                {result?.partnerSessionId}
              </TableRow>
              <TableRow label="Partner Status">
                {result?.partnerStatus}
              </TableRow>
              <TableRow label="Partner Success Indicator">
                {result?.partnerSuccessIndicator}
              </TableRow>
              <TableRow label="Partner Transaction Id">
                {result?.partnerTransactionId}
              </TableRow>
              <TableRow label="Payment Method">
                {result?.paymentMethod}
              </TableRow>
              <TableRow label="Payment Service Provider">
                {result?.paymentServiceProvider}
              </TableRow>
              <TableRow label="Reference">{result?.reference}</TableRow>
              <TableRow label="Retry Count">{result?.retryCount}</TableRow>
              <TableRow label="Reward Point">{result?.rewardPoint}</TableRow>
              <TableRow label="RT Values">{result?.rtValues}</TableRow>
              <TableRow label="Source Amount">{result?.sourceAmount}</TableRow>
              <TableRow label="Source Wallet">{result?.sourceWallet}</TableRow>
              <TableRow label="sPay Response Code">
                {result?.spayResponseCode}
              </TableRow>
              <TableRow label="sPay Response Details">
                {result?.spayResponseDetails}
              </TableRow>
              <TableRow label="sPay Status">{result?.spayStatus}</TableRow>
              <TableRow label="sPay Transaction Date">
                {result?.spayTransactionDate}
              </TableRow>
              <TableRow label="sPay Transaction Id">
                {result?.spayTransactionId}
              </TableRow>
              <TableRow label="sPay User Wallet">
                {result?.spayUserWallet}
              </TableRow>
              <TableRow label="Status">{result?.status}</TableRow>
              <TableRow label="Transaction Id">
                {result?.transactionId}
              </TableRow>
              <TableRow label="Transaction Source">
                {result?.transactionSource}
              </TableRow>
              <TableRow label="Transaction Type">
                {result?.transactionType}
              </TableRow>
              <TableRow label="Transfer Channel">
                {result?.transferChannel}
              </TableRow>
              <TableRow label="Transfer Type">{result?.transferType}</TableRow>
              <TableRow label="Virtual Account Number">
                {result?.virtualAccountNumber}
              </TableRow>
            </tbody>
          </table>
        </div>
      </CustomModal>
    </>
  );
}

type TableRowType = {
  label: string;
  children?: ReactNode;
};

const TableRow = ({ label, children }: TableRowType) => (
  <tr className="border-b">
    <td className="w-60 p-2 flex justify-between">
      {label} <span className="ml-2">:</span>
    </td>
    <td className="w-full p-2">{children || "-"}</td>
  </tr>
);
